import clsx from 'clsx';
import React from 'react';
import { TW_RING } from '../../../../../domain/websiteDomain';
import { FetchSessionsMinimalQueryVariables } from '../../../../../typescript/generated/codegen';

interface LevelProps {
  filters: FetchSessionsMinimalQueryVariables;
  setFilters: (filters: FetchSessionsMinimalQueryVariables) => void;
}

const Level: React.FC<LevelProps> = ({ filters, setFilters }) => {
  const handleSetLevel = (level: string) => {
    if (Array.isArray(filters.levels) && filters.levels.includes(level)) {
      setFilters({ ...filters, levels: undefined });
    } else {
      setFilters({ ...filters, levels: [level] });
    }
  };

  const options = [
    { label: '1', value: 'Level 1' },
    { label: '1-2', value: 'Level 1-2' },
    { label: '2', value: 'Level 2' },
    { label: '2-3', value: 'Level 2-3' },
    { label: '3', value: 'Level 3' },
  ];

  return (
    <div className="flex flex-row items-center justify-between">
      {options.map(level => {
        const isSelected = filters.levels?.includes(level.value);

        return (
          <button
            key={`level-${level.value}`}
            className={clsx(
              'flex flex-row items-center justify-center h-56px w-56px rounded-full border border-accent-light',
              TW_RING,
              isSelected && 'bg-accent-light',
              !isSelected && 'hover:border-accent'
            )}
            onClick={() => handleSetLevel(level.value)}
          >
            {level.label}
          </button>
        );
      })}
    </div>
  );
};

export default Level;
